import apiFetch from '../apiFetch'

export default function (registrationDeliveryId, dossierDetails, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/registrationDelivery/${registrationDeliveryId}`, method: 'PUT', body: dossierDetails, token: token, lastAccessDate })
}
